/* Otter Spirit - Notify me popup (product cards and product page)
   Opens one accessible email popup for sold-out products and sends the sign-up to
   Klaviyo's back-in-stock API. On product pages it takes over the click on Klaviyo's
   own back-in-stock button so the behavior is the same everywhere on the site. */
(function () {
  'use strict';
  if (window.__osCardNotify) { return; }
  window.__osCardNotify = true;

  var COMPANY_ID = 'Ru6dsd';
  var REVISION = '2025-10-15';
  /* Optional: also subscribe the email to a Klaviyo list, for example Newsletter (UWSXZC).
     Empty on purpose: Klaviyo does not require a list for back-in-stock emails. */
  var LIST_ID = '';
  var API = 'https://a.klaviyo.com/client/';
  var STYLE_ID = 'os-card-notify-style';
  var state = null;

  var CSS = [
    '.os-cn-overlay{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:10px;background:rgba(20,20,20,.6);overflow-y:auto}',
    '.os-cn-dialog{position:relative;box-sizing:border-box;width:100%;max-width:400px;margin:auto;padding:24px 40px;background:#fff;color:#00022b;font-family:inherit}',
    '.os-cn-close{position:absolute;top:8px;right:8px;width:32px;height:32px;padding:0;border:0;background:transparent;color:#4b4a4a;font-size:28px;line-height:32px;cursor:pointer}',
    '.os-cn-title{margin:0 0 6px;padding-right:20px;font-size:20px;font-weight:400;line-height:1.4;color:#00022b}',
    '.os-cn-product{margin:0;font-size:15px;color:#2d2e49}',
    '.os-cn-label{display:block;margin-top:16px;font-size:15px;color:#2d2e49}',
    '.os-cn-field{display:block;width:100%;box-sizing:border-box;height:48px;margin:16px 0 0;padding:0 12px;border:1px solid #4b4a4a;border-radius:0;background:#fff;color:#00022b;font-family:inherit;font-size:18px}',
    '.os-cn-label + .os-cn-field{margin-top:4px}',
    '.os-cn-field:focus,.os-cn-submit:focus,.os-cn-close:focus{outline:2px solid #0064cd;outline-offset:2px}',
    '.os-cn-error{min-height:20px;margin:8px 0 0;font-size:14px;line-height:20px;color:#b00020}',
    '.os-cn-submit{display:block;width:100%;height:44px;margin:8px 0 0;border:0;border-radius:5px;background:#00022b;color:#fff;font-family:inherit;font-size:20px;cursor:pointer}',
    '.os-cn-submit[disabled]{opacity:.6;cursor:default}',
    '.os-cn-done{margin:0 0 16px;font-size:36px;font-weight:700;line-height:1.15;color:#00022b}',
    '.os-cn-text{margin:0 0 12px;font-size:20px;line-height:1.4}',
    '@media (max-width:480px){.os-cn-dialog{padding:24px 20px}}'
  ].join('');

  function h(tag, props, children) {
    var node = document.createElement(tag);
    var key;
    props = props || {};
    for (key in props) {
      if (key === 'text') { node.textContent = props[key]; }
      else { node.setAttribute(key, props[key]); }
    }
    (children || []).forEach(function (child) { if (child) { node.appendChild(child); } });
    return node;
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) { return; }
    var style = h('style', { 'id': STYLE_ID });
    style.appendChild(document.createTextNode(CSS));
    document.head.appendChild(style);
  }

  function validEmail(value) {
    var at = value.indexOf('@');
    var dot = value.lastIndexOf('.');
    return value.length > 5 && value.indexOf(' ') === -1 && at > 0 && dot > at + 1 &&
      value.length - dot > 2 && value.indexOf('@', at + 1) === -1;
  }

  function post(path, payload) {
    return fetch(API + path + '?company_id=' + encodeURIComponent(COMPANY_ID), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        var err = new Error('klaviyo ' + response.status);
        err.status = response.status;
        throw err;
      }
    });
  }

  function subscribe(email, variantId) {
    var profile = { data: { type: 'profile', attributes: { email: email } } };
    var bis = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: { profile: profile, channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      }
    };
    return post('back-in-stock-subscriptions/', bis).then(function () {
      if (!LIST_ID) { return; }
      var sub = {
        data: {
          type: 'subscription',
          attributes: { profile: profile, custom_source: 'Back in Stock - Notify me popup' },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      };
      return post('subscriptions/', sub).catch(function () {});
    });
  }

  function loadVariants(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) { throw new Error('product'); }
        return response.json();
      })
      .then(function (product) {
        var options = product.options || [];
        var label = options.length === 1 ? String(options[0].name || options[0]) : 'Choose an option';
        var list = (product.variants || []).filter(function (variant) { return !variant.available; });
        return { label: label, list: list };
      })
      .catch(function () { return null; });
  }

  function focusables(root) {
    return Array.prototype.slice.call(root.querySelectorAll('button:not([disabled]), input, select'));
  }

  function closeModal() {
    if (!state) { return; }
    var s = state;
    state = null;
    if (s.overlay.parentNode) { s.overlay.parentNode.removeChild(s.overlay); }
    document.documentElement.style.overflow = s.prevOverflow;
    if (s.wrapper) {
      if (s.wrapperHidden === null) { s.wrapper.removeAttribute('aria-hidden'); }
      else { s.wrapper.setAttribute('aria-hidden', s.wrapperHidden); }
    }
    if (s.last && s.last.focus) { s.last.focus(); }
  }

  function showDone(dialog, closeBtn) {
    while (dialog.firstChild) { dialog.removeChild(dialog.firstChild); }
    var doneId = 'os-cn-done-' + new Date().getTime();
    var heading = h('h2', { 'class': 'os-cn-done', 'id': doneId, 'tabindex': '-1', 'text': 'You’re all set!' });
    var text = h('p', { 'class': 'os-cn-text', 'role': 'status', 'text': 'Keep an eye out for a back-in-stock message.' });
    dialog.setAttribute('aria-labelledby', doneId);
    dialog.appendChild(closeBtn);
    dialog.appendChild(heading);
    dialog.appendChild(text);
    heading.focus();
  }

  /* card: the product card element, or null on product pages.
     opts: { handle, VariantFirstID (variant to preselect), title (optional) } */
  function open(card, opts) {
    if (state) { return; }
    ensureStyle();
    var uid = 'os-cn-' + new Date().getTime();
    var nameNode = card ? card.querySelector('.t4s-product-title') : null;
    var productName = opts.title || (nameNode ? nameNode.textContent.trim() : '');
    var wrapper = document.querySelector('.t4s-website-wrapper');

    var overlay = h('div', { 'class': 'os-cn-overlay' });
    var dialog = h('div', { 'class': 'os-cn-dialog', 'role': 'dialog', 'aria-modal': 'true', 'aria-labelledby': uid + '-title' });
    var closeBtn = h('button', { 'type': 'button', 'class': 'os-cn-close', 'aria-label': 'Close' });
    closeBtn.textContent = String.fromCharCode(215);
    var title = h('h2', { 'class': 'os-cn-title', 'id': uid + '-title', 'text': 'Receive an email for when this item comes back in stock.' });
    var product = productName ? h('p', { 'class': 'os-cn-product', 'text': productName }) : null;
    var form = h('form', { 'novalidate': 'novalidate' });
    var variantSlot = h('div');
    var email = h('input', { 'type': 'email', 'class': 'os-cn-field', 'name': 'email', 'autocomplete': 'email', 'placeholder': 'Enter your email address', 'aria-label': 'Email address', 'aria-describedby': uid + '-error', 'required': 'required' });
    var error = h('p', { 'class': 'os-cn-error', 'id': uid + '-error', 'role': 'alert' });
    var submit = h('button', { 'type': 'submit', 'class': 'os-cn-submit', 'text': 'NOTIFY ME' });

    form.appendChild(variantSlot);
    form.appendChild(email);
    form.appendChild(error);
    form.appendChild(submit);
    dialog.appendChild(closeBtn);
    dialog.appendChild(title);
    if (product) { dialog.appendChild(product); }
    dialog.appendChild(form);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    state = {
      overlay: overlay,
      last: document.activeElement,
      wrapper: wrapper,
      wrapperHidden: wrapper ? wrapper.getAttribute('aria-hidden') : null,
      prevOverflow: document.documentElement.style.overflow,
      variantId: String(opts.VariantFirstID || '')
    };
    document.documentElement.style.overflow = 'hidden';
    if (wrapper) { wrapper.setAttribute('aria-hidden', 'true'); }
    email.focus();

    loadVariants(opts.handle).then(function (info) {
      if (!state || state.overlay !== overlay || !info || info.list.length < 2) { return; }
      var selectId = uid + '-variant';
      var label = h('label', { 'class': 'os-cn-label', 'for': selectId, 'text': info.label });
      var select = h('select', { 'class': 'os-cn-field', 'id': selectId });
      info.list.forEach(function (variant) {
        var option = h('option', { 'value': String(variant.id), 'text': variant.title });
        if (String(variant.id) === state.variantId) { option.setAttribute('selected', 'selected'); }
        select.appendChild(option);
      });
      state.variantId = select.value;
      select.addEventListener('change', function () { if (state) { state.variantId = select.value; } });
      variantSlot.appendChild(label);
      variantSlot.appendChild(select);
    });

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('mousedown', function (event) { if (event.target === overlay) { closeModal(); } });
    overlay.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key !== 'Tab' && event.keyCode !== 9) { return; }
      var items = focusables(dialog);
      if (!items.length) { return; }
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (items.indexOf(active) === -1) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var value = email.value.trim();
      if (!validEmail(value)) {
        email.setAttribute('aria-invalid', 'true');
        error.textContent = 'Please enter a valid email address.';
        email.focus();
        return;
      }
      email.removeAttribute('aria-invalid');
      error.textContent = '';
      if (!state || !state.variantId) {
        error.textContent = 'Sorry, something went wrong. Please try again.';
        return;
      }
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      subscribe(value, state.variantId).then(function () {
        if (state && state.overlay === overlay) { showDone(dialog, closeBtn); }
      }, function (err) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        error.textContent = err && err.status === 400
          ? 'Please enter a valid email address.'
          : 'Sorry, we could not save your request. Please try again.';
      });
    });
  }

  function takeOver(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) { event.stopImmediatePropagation(); }
  }

  /* Capture phase so these run before any other handler on the buttons. */

  /* 1. Sold-out product cards (collections, home, search...). */
  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('.t4s-pr-addtocart') : null;
    if (!button) { return; }
    var card = button.closest('.t4s-product[data-product-options]');
    if (!card) { return; }
    var opts;
    try { opts = JSON.parse(card.getAttribute('data-product-options')); } catch (e) { return; }
    if (!opts || opts.available !== false || opts.isExternal) { return; }
    takeOver(event);
    open(card, opts);
  }, true);

  /* 2. Product page: Klaviyo's own back-in-stock button. If anything needed is
     missing, we do nothing and Klaviyo's popup opens as before. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('#klaviyo-bis-button-container button') : null;
    if (!button) { return; }
    var form = button.closest('form');
    var idField = form ? form.querySelector('[name=id]') : null;
    var part = window.location.pathname.split('/products/')[1];
    var handle = part ? part.split('/')[0] : '';
    if (!handle || !idField || !idField.value) { return; }
    var heading = document.querySelector('h1');
    takeOver(event);
    open(null, { handle: handle, VariantFirstID: idField.value, title: heading ? heading.textContent.trim() : '' });
  }, true);
})();
